import gql from 'graphql-tag';
export const CREATE_PORTAL_SESSION_FROM_CUSTOMER_ID = gql`
    mutation createPortalSessionFromCustomerID($customer: ID!){
        createPortalSessionFromCustomerID(customer: $customer)
    }
`;